import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Assistant from "@/components/site/Assistant";
import MobileCallBar from "@/components/site/MobileCallBar";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div data-testid="site-layout">
      <a href="#main-content" className="gp-skiplink" data-testid="skip-link">
        Skip to content
      </a>
      <Header />
      <main id="main-content" data-testid="site-main" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <MobileCallBar />
      <Assistant />
    </div>
  );
}
